var React = require('react');

function HamburgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n        .hamburger-menu .a{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}\n      ")),React.createElement("g",{"transform":"translate(-2.25 -5.25)","key":1},[React.createElement("line",{"className":"a","x2":"18","transform":"translate(3 12)","key":0}),React.createElement("line",{"className":"a","x2":"18","transform":"translate(3 6)","key":1}),React.createElement("line",{"className":"a","x2":"18","transform":"translate(3 18)","key":2})])]);
}

HamburgerMenu.defaultProps = {"width":"30","height":"13.5","viewBox":"0 0 19.5 13.5","className":"hamburger-menu"};

module.exports = HamburgerMenu;

HamburgerMenu.default = HamburgerMenu;
